/**
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-23 10:51:46
 * @FilePath: src/api/app.js
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
/**
 * @Author 22030124/xieyq
 * @Date 2023-11-21 13:35:27
 * @Description 应用相关请求入口js
 */
import request from '@/utils/request'

/**
 * 请求应用列表分类
 * @returns {Promise}
 */
export function requestAppGroups() {
  return request({
    url: '/base/app/groupByCategory',
    method: 'get'
  })
}
/**
 * 请求应用列表分类
 * @returns {Promise}
 */
export function appWithCanAccess() {
  return request({
    url: '/base/app/appWithCanAccess',
    method: 'get'
  })
}

/**
 * 请求按领域分组的应用列表（支持可选查询参数）
 * @param {Object} [params] 可选，如 { domainType }
 * @returns {Promise}
 */
export function requestAppGroupsByDomain(params) {
  return request({
    url: '/base/app/groupByDomain',
    method: 'get',
    params
  })
}

// Ai 生成logo
export function aiCreate(name) {
  return request({
    url: '/api/f/gen_logo',
    method: 'get',
    params: {
      agent_name: name
    }
  })
}

/**
 * 请求应用列表
 * @returns {Promise}
 */
export function requestApps(appIds) {
  return request({
    url: '/base/app/list',
    method: 'get',
    params: {
      appIds
    }
  })
}

/**
 * 请求常用应用列表
 * @returns {Promise}
 */
export function requestQuickApps(num) {
  return request({
    url: '/base/app/quick/list',
    method: 'get',
    params: {
      topK: num
    }
  })
}

/**
 * 设置常用应用
 * @returns {Promise}
 */
export function setQuickApps(appId) {
  return request({
    url: '/base/app/quick/hold/set',
    method: 'get',
    params: {
      appId: appId
    }
  })
}
/**
 * 取消常用应用
 * @returns {Promise}
 */
export function cancelQuickApps(appId) {
  return request({
    url: '/base/app/quick/hold/cancel',
    method: 'get',
    params: {
      appId: appId
    }
  })
}
/**
 * 应用访问计数
 * @returns {Promise}
 */
export function incrementQuickApps(appId) {
  return request({
    url: '/base/app/quick/increment',
    method: 'get',
    params: {
      appId: appId
    }
  })
}

/**
 * 请求应用列表
 * @returns {Promise}
 */
export function requestAppsPage(params) {
  return request({
    url: '/base/app/page',
    method: 'get',
    params
  })
}

/**
 * 请求创建应用
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function requestCreateApp(data) {
  return request({
    url: '/base/app/create',
    method: 'POST',
    data
  })
}

/**
 * 请求更新应用
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function requestUpdateApp(data) {
  return request({
    url: '/base/app/update',
    method: 'POST',
    data
  })
}

/**
 * 请求更新应用状态
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function updateStatus(data) {
  return request({
    url: '/base/app/status',
    method: 'POST',
    data
  })
}

/**
 * 请求删除应用
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function requestDeleteApp(id) {
  return request({
    url: `/base/app/delete?appId=${id}`,
    method: 'POST'
  })
}
/**
 * 批量删除应用
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function patchDeleteApp(ids) {
  return request({
    url: `/base/app/patchDelete?appIds=${ids}`,
    method: 'POST'
  })
}

/**
 * 请求组件列表
 * @param {String} appId 应用id
 * @returns {Promise}
 */
export function requestComponentsByAppId(appId) {
  return request({
    url: '/base/block/findByAppId',
    method: 'GET',
    params: {
      appId
    }
  })
}

/**
 * 请求创建组件
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function requestCreateComponent(data) {
  return request({
    url: '/base/block/create',
    method: 'POST',
    data
  })
}

/**
 * 请求更新组件
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function requestUpdateComponent(data) {
  return request({
    url: '/base/block/update',
    method: 'POST',
    data
  })
}

/**
 * 请求发布组件
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function requestPublishComponent(data) {
  return request({
    url: '/base/block/audit',
    method: 'POST',
    data
  })
}

/**
 * 请求工作台列表
 * @returns {Promise}
 */
export function requestWorkbenches() {
  return request({
    url: '/workplace/api/workplace/user/workplaces',
    method: 'get'
  })
}

/**
 * 请求应用分类列表分类
 * @returns {Promise}
 */
export function requestAppCategory(params) {
  return request({
    url: '/base/appCategory/page',
    method: 'get',
    params
  })
}

/**
 * 新增应用分类
 * @returns {Promise}
 */
export function requestAppCategoryCreate(data) {
  return request({
    url: '/base/appCategory/create',
    method: 'POST',
    data
  })
}

/**
 * 更新应用分类
 * @returns {Promise}
 */
export function requestAppCategoryUpdate(data) {
  return request({
    url: '/base/appCategory/update',
    method: 'POST',
    data
  })
}

/**
 * 删除应用分类
 * @returns {Promise}
 */
export function requestAppCategoryDelete(appCategoryId) {
  return request({
    url: '/base/appCategory/delete',
    method: 'POST',
    params: {
      appCategoryId
    }
  })
}

/**
 * 分类下设置应用绑定
 * PUT /base/appCategory/bind/app
 * @param {{ categoryId: number|string, domainId: number|string, appIds: (number|string)[] }} data
 */
export function requestBindAppsToCategory(data) {
  return request({
    url: '/base/appCategory/bind/app',
    method: 'PUT',
    data
  })
}

/**
 * 绑定应用分类行业标签
 * POST /base/appCategory/industryLabel
 * @param {{ appCategoryId: number|string, industryLabel: string }} data
 */
export function requestBindIndustryLabel(data) {
  return request({
    url: '/base/appCategory/industryLabel',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: `appCategoryId=${data.appCategoryId}&industryLabel=${encodeURIComponent(data.industryLabel)}`
  })
}

/**
 * 按应用绑定分类
 * POST /base/app/bind/category
 * @param {{ appId: number|string, appCategories: Array }} data
 */
export function requestBindCategoriesToApp(data) {
  return request({
    url: '/base/app/bind/category',
    method: 'PUT',
    data
  })
}

/**
 * 更新应用分类全集列表
 * @returns {Promise}
 */
export function requestAppCategoryList() {
  return request({
    url: '/base/appCategory/list',
    method: 'GET'
  })
}

/**
 * 获取子应用菜单信息
 * @returns {Promise}
 */
export function requestAppMenuList(id) {
  return request({
    url: `/base/app/menu/tree?appId=${id}`,
    method: 'GET'
  })
}
/**
 * 切换工作台记录
 * @returns {Promise}
 */
export function switchWorkplace(id) {
  return request({
    url: `/base/user/switchWorkplace?workplaceId=${id}`,
    method: 'GET'
  })
}

/**
 * 请求应用领域分页列表
 * @returns {Promise}
 */
export function requestAppDomain(params) {
  return request({
    url: '/base/appDomain/page',
    method: 'GET',
    params
  })
}

/**
 * 根据ID查询应用领域
 * @returns {Promise}
 */
export function requestAppDomainById(id) {
  return request({
    url: '/base/appDomain',
    method: 'GET',
    params: { id }
  })
}

/**
 * 新增应用领域
 * @returns {Promise}
 */
export function requestAppDomainCreate(data) {
  return request({
    url: '/base/appDomain',
    method: 'POST',
    data
  })
}

/**
 * 更新应用领域
 * @returns {Promise}
 */
export function requestAppDomainUpdate(data) {
  return request({
    url: '/base/appDomain',
    method: 'PUT',
    data
  })
}

/**
 * 删除应用领域
 * @returns {Promise}
 */
export function requestAppDomainDelete(id) {
  return request({
    url: '/base/appDomain',
    method: 'DELETE',
    data: { id }
  })
}

/**
 * 获取应用领域全部列表（用于下拉选择）
 * @returns {Promise}
 */
export function requestAppDomainList() {
  return request({
    url: '/base/appDomain/list',
    method: 'GET'
  })
}

/**
 * 获取应用领域的视角类型列表（用于单选）
 * @returns {Promise}
 */
export function requestAppDomainTypeList() {
  return request({
    url: '/base/appDomain/getDomainType',
    method: 'GET'
  })
}
// 同步应用数据
export function syncApp(url, data) {
  return request({
    url: '/base/app/sync',
    method: 'post',
    data
  })
}
// 查询应用维护人
export function getAppAdminList(params) {
  return request({
    url: '/base/app/admin/list',
    method: 'get',
    params
  })
}
// 添加应用维护人
export function addAppAdmin(data) {
  return request({
    url: '/base/app/admin/update',
    method: 'post',
    data
  })
}
// 删除应用维护人
export function removeAppAdmin(data) {
  return request({
    url: '/base/app/admin/remove',
    method: 'post',
    data
  })
}
// 获取应用权限申请地址
export function getAppApplyUrl(params) {
  return request({
    url: '/base/app/access/url',
    method: 'get',
    params
  })
}
